// First-party ad/UTM attribution.
// Captures utm_* + gclid/fbclid from the URL on landing, keeps the FIRST-touch
// in localStorage (so we credit the original ad even after later navigation),
// beacons every visit to the backend, and exposes the stored attribution so the
// signup flow can stamp it onto the new user.
import { api } from "@/lib/api";

const STORE_KEY = "vt_attribution";
const VISITOR_KEY = "vt_visitor_id";
const VISIT_SESSION_KEY = "vt_visit_sent";

function uuid() {
    try { return crypto.randomUUID(); } catch { return `v-${Date.now()}-${Math.random().toString(36).slice(2)}`; }
}

export function getVisitorId() {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) { id = uuid(); localStorage.setItem(VISITOR_KEY, id); }
    return id;
}

function parseParams() {
    const p = new URLSearchParams(window.location.search || "");
    const pick = (...keys) => {
        for (const k of keys) { const v = p.get(k); if (v) return v.slice(0, 300); }
        return null;
    };
    return {
        source: pick("utm_source"),
        medium: pick("utm_medium"),
        campaign: pick("utm_campaign"),
        content: pick("utm_content"),
        term: pick("utm_term"),
        gclid: pick("gclid"),
        fbclid: pick("fbclid"),
    };
}

function hasAnySignal(o) {
    return !!(o.source || o.medium || o.campaign || o.gclid || o.fbclid);
}

export function getStoredAttribution() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || "null"); } catch { return null; }
}

// Capture (first-touch) + beacon a visit. Call once on app load.
export function captureAndTrack() {
    const parsed = parseParams();
    const referrer = (document.referrer || "").slice(0, 300) || null;
    const landing_path = (window.location.pathname || "/").slice(0, 120);

    // First-touch persistence: only write if we have a real signal and nothing stored yet.
    const existing = getStoredAttribution();
    if (!existing && hasAnySignal(parsed)) {
        try {
            localStorage.setItem(STORE_KEY, JSON.stringify({
                ...parsed, referrer, landing_path,
                first_seen: new Date().toISOString(),
            }));
        } catch { /* ignore */ }
    }

    // Beacon the visit (once per browser session) — captures organic/direct too.
    try {
        if (sessionStorage.getItem(VISIT_SESSION_KEY)) return;
        sessionStorage.setItem(VISIT_SESSION_KEY, "1");
    } catch { /* ignore */ }

    api.post("/track/visit", {
        visitor_id: getVisitorId(),
        ...parsed,
        referrer,
        landing_path,
    }).catch(() => { /* best-effort */ });
}
